
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/in-the-news",
      function () {
        return require("private-next-pages/in-the-news/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/in-the-news"])
      });
    }
  